import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomeNav from './HomeNav';
import HomeAbout from './HomeAbout';
import HomeBragBar from './HomeBragBar';
import HomeWorkedWith from './HomeWorkedWith';
import HomeApplyForm from './HomeApplyForm';
import HomeFooter from './HomeFooter';
import TeamDashboard from './TeamDashboard';
import NewsletterSubscribers from './NewsletterSubscribers';
import Imprint from './Imprint';
import AnimatedOrbs from './AnimatedOrbs';
import './Home.css';
import './App.css';
import './DarkMode.css';

import StickyLogo from './StickyLogo';

function App() {
  return (
    <Router>
      <StickyLogo />
      <AnimatedOrbs />
      <Routes>
        <Route path="/" element={
          <div className="home-root">
            <HomeNav />
            <HomeAbout />
            <HomeBragBar />
            <HomeWorkedWith />
            <HomeApplyForm />
            <HomeFooter />
          </div>
        } />
        <Route path="/teamdashboard" element={<TeamDashboard />} />
        <Route path="/newsletter-subscribers" element={<NewsletterSubscribers />} />
        <Route path="/imprint" element={
          <div className="home-root">
            <Imprint />
            <HomeFooter />
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
